if (!customElements.get('lumera-external-buy')) {
  customElements.define('lumera-external-buy', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.native = this.form?.closest('product-form');
      this.select = this.querySelector('[data-lumera-supply]');
      this.link = this.querySelector('[data-lumera-buy]');
      this.links = JSON.parse(this.querySelector('[data-lumera-links]').textContent);
      if (!this.scope || !this.form || !this.native) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.scope.addEventListener('change', (event) => {
        if (event.target.closest('product-info') !== this.scope) return;
        if (event.target.closest('variant-selects')) {
          this.pending = true;
          this.link.removeAttribute('href');
          this.link.setAttribute('aria-disabled', 'true');
          this.link.setAttribute('tabindex', '-1');
        } else if (event.target.matches('input[name="id"]')) {
          this.pending = false;
          this.update(event.target.value);
        } else if (event.target === this.select && !this.pending) {
          this.update(this.variantId);
        }
      }, options);
      this.scope.addEventListener('submit', (event) => {
        if (event.target !== this.form) return;
        if (this.pending || this.url) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.pending && this.url) window.location.assign(this.url);
        }
      }, { capture: true, signal: this.controller.signal });
      this.link.addEventListener('click', (event) => {
        if (this.pending || !this.url) event.preventDefault();
      }, options);
      this.update(this.form.querySelector('input[name="id"]')?.value || this.dataset.variantId);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    update(variantId) {
      this.variantId = String(variantId);
      const supplies = this.links[this.variantId] || {};
      for (const option of this.select.options) option.disabled = !supplies[option.value]?.trim();
      if (!supplies[this.select.value]?.trim()) this.select.value = '1';
      const candidate = supplies[this.select.value]?.trim();
      this.url = '';
      if (candidate) {
        const parsed = new URL(candidate);
        if (parsed.protocol === 'https:' && parsed.hostname === 'trinitycellscience.patient.oladigital.health') this.url = candidate;
      }
      const active = Boolean(this.url);
      this.hidden = !active;
      this.native.hidden = active;
      this.scope.toggleAttribute('data-lumera-three-month', active && this.select.value === '3');
      if (active) {
        this.link.href = this.url;
        this.link.removeAttribute('aria-disabled');
        this.link.removeAttribute('tabindex');
      } else {
        this.link.removeAttribute('href');
        this.link.setAttribute('aria-disabled', 'true');
        this.link.setAttribute('tabindex', '-1');
      }
    }
  });
}
